import { API, authClient } from "..";

// Get all scenes (optional filter by game)
export const getScenes = (gameId) => {
	return authClient().get(`${API}/scene`, gameId ? { params: { game: gameId } } : {});
};

// Get the specified scene
export const getSceneById = (id) => {
	return authClient().get(`${API}/scene/${id}`);
};

// Get the specified scene stats
export const getSceneStatistics = (id) => {
	return authClient().get(`${API}/scene/stats/${id}`);
};
